import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTelegram } from '../hooks/useTelegram';

interface HeaderProps {
  title?: string;
  showBack?: boolean;
}

const Header: React.FC<HeaderProps> = ({ title, showBack = false }) => {
  const navigate = useNavigate();
  const { hapticImpact } = useTelegram();

  return (
    <header
      style={{
        padding: '16px 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'sticky',
        top: 0,
        zIndex: 50,
        background: 'rgba(245,245,244,0.7)',
        backdropFilter: 'blur(24px) saturate(180%)',
        WebkitBackdropFilter: 'blur(24px) saturate(180%)',
      }}
    >
      {showBack ? (
        <button
          onClick={() => {
            hapticImpact('light');
            navigate(-1);
          }}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            fontSize: '14px',
            fontWeight: 500,
            color: '#6E6E73',
            background: 'none',
            border: 'none',
            padding: '4px 0',
            fontFamily: "'Instrument Sans', -apple-system, sans-serif",
            cursor: 'pointer',
            WebkitTapHighlightColor: 'transparent',
          }}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
          Назад
        </button>
      ) : (
        <div
          style={{
            fontFamily: "'DM Serif Display', Georgia, serif",
            fontSize: '18px',
            color: '#111111',
            letterSpacing: '-0.02em',
          }}
        >
          {title || (
            <>
              aegis.studio
              <span
                style={{
                  display: 'inline-block',
                  width: '6px',
                  height: '6px',
                  background: '#111111',
                  borderRadius: '50%',
                  marginLeft: '2px',
                }}
              />
            </>
          )}
        </div>
      )}
    </header>
  );
};

export default Header;
